export default {
  config: {},
};
